import React, { useState } from 'react';
export const SeveritySlider = ({
  onSelect
}) => {
  const [value, setValue] = useState(0);
  const getSeverityLabel = val => {
    if (val <= 2) return 'Mild';
    if (val <= 5) return 'Moderate';
    if (val <= 7) return 'Severe';
    return 'Extreme';
  };
  const handleChange = e => {
    setValue(Number(e.target.value));
  };
  const handleComplete = () => {
    onSelect(value.toString());
  };
  return <div className="w-full space-y-6" data-id="element-31">
      <div className="flex justify-between items-baseline" data-id="element-32">
        <span className="text-2xl font-bold" data-id="element-33">{value}</span>
        <span className="text-gray-600" data-id="element-34">{getSeverityLabel(value)}</span>
      </div>
      <div className="relative" data-id="element-35">
        <input type="range" min="0" max="10" value={value} onChange={handleChange} className="w-full h-2 bg-gradient-to-r from-green-500 via-yellow-500 to-red-500 rounded-lg appearance-none cursor-pointer" style={{
        '--range-color': `hsl(${120 - value * 12}, 100%, 50%)`
      }} data-id="element-36" />
      </div>
      <button onClick={handleComplete} className="w-full py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-37">
        Confirm Severity
      </button>
      <style jsx data-id="element-38">{`
        input[type='range']::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 24px;
          height: 24px;
          background: white;
          border: 2px solid var(--range-color);
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.15s ease;
        }
        input[type='range']::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }
      `}</style>
    </div>;
};